import { configureStore } from '@reduxjs/toolkit'

import reducer from './reducers'
import middleware from './middlewares'

// Interfaces
import { IService } from '../shared/interfaces/service.interface'

export const store = (services: IService) =>
  configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(middleware.map((f: any) => f(services))),
    devTools: process.env.NODE_ENV === 'development',
  })
